<template>
  <section class="project">
    <div class="back-white"></div>
    <div class="project-content">
      <h2 class="title">主要客户</h2>
      <div class="bar">
        <div class="circular"></div>
      </div>
      <p class="subheading">我们公司与多家顶尖不同地区公司共创辉煌</p>
      <!-- <div class="Join-us">
        <button>加入我们</button>
        <a>点击这，免费尝试加入我们</a>
      </div> -->
      <!-- <h5 class="introduction">更多的优秀企业陆续加入我们科技行业更加壮大威武</h5> -->
      <div class="solution">
        <div class="solution-content">
          <div class="first">
            <div class="grid-content">
                <!-- <div class="icon">
                  <div class="back-image"></div>
                  <img src="@/assets/img/pic1.png"/>
                </div>
                <h3>智能配电技术为核心</h3>
                <p class="detailed">
                  测试测试测试我们公司是这么解决的非常便利测试测试测试我们公司是么解决的非常便利测试我们公司
                </p>
                <a>
                  <v-icon class="flaticon-software" name="arrow-right"/>
                </a> -->
                <div class="image">
                   <img class="partners" src="@/assets/img/partners1_1.png"/>
                   <img class="partners" src="@/assets/img/partners2.png"/>
                   <img class="partners" src="@/assets/img/partners3_1.png"/>
                   <img class="partners" src="@/assets/img/partners4_1.png"/>
                   <img class="partners" src="@/assets/img/partners6_1.png"/>
                   <img class="partners" src="@/assets/img/partners5.png"/>
                   <img class="partners" src="@/assets/img/partners6.png"/>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "project"
}
</script>

<style lang="scss" scoped>
.project{
  position: relative;
  width: 100%;
  padding-top: 70px;
  z-index: 1;
  background: linear-gradient(135deg, #23bdb8 0%, #43e794 100%);
}

.back-white{
  position: absolute;
  bottom: 0;
  left: 0;
  height: 37%;
  width: 100%;
  background: #ffffff;
  z-index: -1;
}

.project-content {
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
  
  @media (min-width: 576px) {
    max-width: 540px;
  }
 
  @media (max-width: 767px) {
    .grid-content{
      .image{
        .partners{
          width: 100px;
        }
      }
    }
  }
  
  @media (min-width: 768px) {
    max-width: 620px;
  }
  
  @media (min-width: 992px) {
    max-width: 860px;
  }
  
  @media (min-width: 1200px) {
    max-width: 1140px;
  }
}

.title{
  color: #fff;
  font-size: 22px;
  margin: 0;
}

.bar {
  height: 4px;
  width: 90px;
  background: #cdf1d8;
  margin: 20px auto;
  position: relative;
  border-radius: 40px;

  .circular {
    position: absolute;
    left: 0;
    top: -3.2px;
    height: 10px;
    width: 10px;
    border-radius: 50%;
    background: #ffffff;
    animation: mymove 4s infinite;
    -webkit-animation: mymove 4s infinite; /*Safari and Chrome both*/
   
    @keyframes mymove {
      from {
        left: 0px;
      }

      to {
        left: 82px;
      }
    }
    
    @-webkit-keyframes mymove /*Safari and Chrome*/ {
      from {
        left: 0px;
      }

      to {
        left: 82px;
      }
    }
  }
}

.subheading {
  color: #fff;
  // font-size: 16px;
  font-size: 14px;
  max-width: 520px;
  margin: 20px auto;
  line-height: 1.9;
}

.Join-us{
  button{
    background-color: #c679e3;
    box-shadow: 0 13px 27px 0 rgba(68, 206, 111, 0.25);
    color: #ffffff;
    border: none;
    padding: 15px 40px;
    border-radius: 4px;
    text-transform: uppercase;
    transition: 0.5s;
    font-weight: 600;
    font-size: 14px;

    &:hover{
      transform: translateY(-10px);
      cursor: pointer;
      color: #0e314c;
      background: #ffffff;
      box-shadow: 0 5px 20px 0 rgba(68, 206, 111, 0.25)
    }
  }

  a{
    margin-left: 15px;
    color: #ffffff;
    font-size: 14px;
    text-decoration: underline;
  }
}

.introduction{
  margin: 20px 0;
  color: #ffffff;
  font-size: 18px;
  font-weight: 400;
  
}

.solution {
  display: flex;
  &:last-child {
    margin-bottom: 0;
  }
}

.solution-content {
  position: relative;
  padding: 0 15px;
  flex: 1;
}

.first{
  &:hover {
    background-image: url("../../assets/img/1.jpg");
    background-position: center;
    background-size: calc(100% - 2px)  calc(100% - 2px);
    background-repeat: no-repeat;
  }
}

.second{
  &:hover {
    background-image: url("../../assets/img/2.jpg");
    background-position: center;
    background-size: calc(100% - 2px)  calc(100% - 2px);
    background-repeat: no-repeat;
  }
}

.third{
  &:hover {
    background-image: url("../../assets/img/3.jpg");
    background-position: center;
    background-size: calc(100% - 2px)  calc(100% - 2px);
    background-repeat: no-repeat;
  }
}

.grid-content {
  position: relative;
  padding: 30px;
  text-align: center;
  background-color: #ffffff;
  box-shadow: 0 2px 48px 0 rgba(0, 0, 0, 0.08);
  border-radius: 3px;
  z-index: 1;
  -webkit-transition: 0.5s;
  transition: 0.5s;

  .image{
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
    align-items: center;

    .partners{
      padding: 20px;
      width: 18%;
    }
  }
  
  &:hover {
    a{
      background-color: #e36cd9;
      .flaticon-software{
        cursor: pointer;
        color: #ffffff;
      }
    }

  }
}

.icon {
  display: inline-block;
  border: 1px solid #f3f8fd;
  width: 90px;
  height: 90px;
  line-height: 112px;
  border-radius: 50%;
  position: relative;
  z-index: 1;

  .back-image{
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    z-index: -1;
    bottom: 0;
    background: #f7fafd;
    border-radius: 50%;
    margin: 6px;
    -webkit-transition: 0.5s;
    transition: 0.5s;
  }
  
  img{
    width: 40px;
  }
}
</style>